import { QueryFactory } from "../../../../Common";
import { SD } from "../../../../Contracts";
export const QGetEventsByEventId = QueryFactory(SD.QueryTypes.GetEventsByEventId);
//# sourceMappingURL=QGetEventsByEventId.js.map